import { loadingBarReducer } from 'react-redux-loading-bar'
import { reducer as notifsReducer } from 'reapop'

import auth from './auth'
import modal from './modal'
import customers from './customers'
import banners from './banners'
import categories from './categories'
import notifications from './notifications'
import orders from './orders'
import products from './products'
import promotions from './promotions'
import surveys from './surveys'
import users from './users'
import usersNotifications from './usersNotifications'
import payment from './payment'
import upselling from './upselling'
import coupons from './coupons'
import rating from './rating'
import mosques from './mosques'
import configurations from './configurations'
import booklets from './booklets'
import subscriptions from './subscriptions'
import advertisements from './advertisements'
import mosqueRequests from './mosqueRequests'
import termsConditions from './termsConditions'
import faq from './faq'
import aboutUs from './aboutUs'
import deliveryAreas from './deliveryAreas'
import governorates from './governorates'

const rootReducer = {
  auth,
  modal,
  customers,
  banners,
  categories,
  notifications,
  orders,
  products,
  promotions,
  surveys,
  users,
  usersNotifications,
  payment,
  upselling,
  coupons,
  rating,
  booklets,
  mosques,
  configurations,
  advertisements,
  subscriptions,
  mosqueRequests,
  termsConditions,
  faq,
  aboutUs,
  deliveryAreas,
  governorates,
  notifs: notifsReducer(),
  loadingBar: loadingBarReducer,
}

export default rootReducer
